module.exports = __webpack_public_path__ + "static/media/app-icon-256x256.86c18ed2.png";